function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StripeElements from '../../../components/stripe/StripeElements';
import PaymentMethodStep from '../../../components/wizard/PaymentMethodStep';
import { listUserCards, setPaymentMethodId, setSelectedPayMode } from '../../../redux/actions';
import { useWizard } from 'react-use-wizard';
var MembershipManagementPaymentStep = function(param) {
    var onSubmit = param.onSubmit, nextButtonProps = param.nextButtonProps, isAssignedPayment = param.isAssignedPayment;
    var nextStep = useWizard().nextStep;
    var dispatch = useDispatch();
    var _useSelector = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile,
            userProfileState: state.profileReducer.userProfileState,
            selectedPayMode: state.order.selectedPayMode,
            membershipPriceId: state.order.membershipPriceId,
            paymentMethodId: state.order.paymentMethodId
        };
    }), paymentMethodId = _useSelector.paymentMethodId, currentUser = _useSelector.currentUser, userProfileState = _useSelector.userProfileState, selectedPayMode = _useSelector.selectedPayMode, membershipPriceId = _useSelector.membershipPriceId;
    var handleAddCard = function() {
        return dispatch(listUserCards());
    };
    var handleSubmit = function(param) {
        var payerName = param.payerName, payerEmail = param.payerEmail, message = param.message;
        onSubmit({
            paymentMethodId: paymentMethodId,
            membershipPriceId: membershipPriceId,
            payerEmail: payerEmail,
            payerName: payerName,
            message: message
        });
        // if not Send to Payer, proceed go to Confirmation
        if (!isAssignedPayment) {
            nextStep();
        }
    };
    var handleSelectedPayMode = function(event) {
        return dispatch(setSelectedPayMode(event.currentTarget.value));
    };
    // commented to hide for FREE user wanted to subscribe w/o going thru TRIAL
    // isTrialDetailsVisible={
    //   !isUserUnderTrial(currentUser) &&
    //   !userHasValidMembership(currentUser) &&
    //   !currentUser.has_used_trial
    // }
    return /*#__PURE__*/ React.createElement(PaymentMethodStep, {
        onAddCard: handleAddCard,
        onPaymentMethodChange: function(paymentMethodId) {
            return dispatch(setPaymentMethodId(paymentMethodId));
        },
        handleSubmit: handleSubmit,
        currentUser: currentUser,
        userProfileState: userProfileState,
        paymentMethodId: paymentMethodId,
        selectedPayMode: selectedPayMode,
        handleSelectedPayMode: handleSelectedPayMode,
        isAssignedPayment: isAssignedPayment,
        nextButtonProps: _object_spread({
            disabled: !paymentMethodId
        }, nextButtonProps)
    });
};
var MembershipManagementPaymentStepWithStripe = function(param) {
    var isAssignedPayment = param.isAssignedPayment, onSubmit = param.onSubmit, nextButtonProps = param.nextButtonProps;
    return /*#__PURE__*/ React.createElement(StripeElements, null, /*#__PURE__*/ React.createElement(MembershipManagementPaymentStep, {
        isAssignedPayment: isAssignedPayment,
        onSubmit: onSubmit,
        nextButtonProps: nextButtonProps
    }));
};
export default MembershipManagementPaymentStepWithStripe;
